import * as React from "react";
const SvgFiRrSafeBox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-safe-box_svg__a)">
      <path
        fill="#062147"
        d="M24 5v10a5 5 0 0 1-2 3.997V21a1 1 0 0 1-2 0v-1.101A5 5 0 0 1 19 20h-4a1 1 0 0 1 0-2h4c1.654 0 3-1.346 3-3h-1a1 1 0 0 1 0-2h1V7h-1a1 1 0 0 1 0-2h1c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v2a1 1 0 0 1-2 0V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-12 7.5v8c0 1.995-2.58 3.5-6 3.5s-6-1.505-6-3.5v-8C0 10.505 2.58 9 6 9s6 1.505 6 3.5m-2 2.652C8.954 15.685 7.565 16 6 16s-2.954-.315-4-.848V16.5c0 .529 1.519 1.5 4 1.5s4-.971 4-1.5zM2 12.5c0 .529 1.519 1.5 4 1.5s4-.971 4-1.5S8.481 11 6 11s-4 .971-4 1.5m8 8v-1.348C8.954 19.685 7.565 20 6 20s-2.954-.315-4-.848V20.5c0 .529 1.519 1.5 4 1.5s4-.971 4-1.5m4.399-6.701a1 1 0 0 0 1.4-.198A5.94 5.94 0 0 0 17 10c0-3.309-2.691-6-6-6a5.94 5.94 0 0 0-3.601 1.201A1 1 0 0 0 8.6 6.8a4.004 4.004 0 0 1 6.4 3.201 3.96 3.96 0 0 1-.799 2.399 1 1 0 0 0 .199 1.4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-safe-box_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSafeBox;
